export const InvalidRequestTokenError = new TypeError('Invalid request token')

export const InvalidUserTokenError = new TypeError('Invalid user token')

export const InvalidEmployeeNoError = new TypeError('Invalid employee no')

export const InvalidRedirectUrlError = new TypeError('Invalid redirect url')

export const InvalidPaylodUrlError = new TypeError('Invalid payload url')

export const InvalidLoginPayload = new TypeError(
  'Invalid login payload, rtoken and utoken is required',
)

export const NotInitError = new TypeError('Not init, this method should not be called')
